import * as fromDatatype from '../datatype-library/index';
import { RuleNodeConditionalFilterInterface } from '../datatype-library/postgresql/json-datatype.model';

// export interface JsonDatatypeConditionalFilterInterface extends 
//   fromDatatype.HdrDocConditionalFilterInterface, 
//   fromDatatype.MultiLineDocFilterInterface,
//   fromDatatype.SingleLineDocFilterInterface {}
  
// export interface CommissionSchemeCreateMain {
//   code: string;
//   name: string;
//   status: string;
//   descr: string;
// }

// export class JsonDatatypeConditionalFilterClass implements JsonDatatypeConditionalFilterInterface{
//   hdr_doc_filter: RuleNodeConditionalFilterInterface;
//   multi_line_doc_filter: RuleNodeConditionalFilterInterface;
//   single_line_doc_filter: RuleNodeConditionalFilterInterface;
  
//   constructor(params: JsonDatatypeConditionalFilterInterface){
//     this.hdr_doc_filter = params.hdr_doc_filter; 
//     this.multi_line_doc_filter = params.multi_line_doc_filter; 
//     this.single_line_doc_filter = params.single_line_doc_filter;
//   }
// }

export interface bl_fi_sales_commission_report_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_guid: fromDatatype.GuidDataFieldInterface;
  mlm_upline_entity_guid: fromDatatype.GuidDataFieldInterface;
  mlm_upline_membership_guid: fromDatatype.GuidDataFieldInterface;
  mlm_program_participant_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_invoice_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_payment_guid: fromDatatype.GuidDataFieldInterface;
  report_type: fromDatatype.VarcharDatatypeInterface;
  report_code: fromDatatype.VarcharDatatypeInterface;
  report_name: fromDatatype.VarcharDatatypeInterface;
  mlm_lineage_absolute_level: fromDatatype.VarcharDatatypeInterface;
  client_status_01: fromDatatype.VarcharDatatypeInterface;
  client_status_02: fromDatatype.VarcharDatatypeInterface;
  client_status_03: fromDatatype.VarcharDatatypeInterface;
  client_status_04: fromDatatype.VarcharDatatypeInterface;
  client_status_05: fromDatatype.VarcharDatatypeInterface;
  commission_money_currency: fromDatatype.VarcharDatatypeInterface;
  commission_point_currency: fromDatatype.VarcharDatatypeInterface;
  gendoc_invoice_currency: fromDatatype.VarcharDatatypeInterface;
  gendoc_payment_currency: fromDatatype.VarcharDatatypeInterface;
  sales_doc_amount_txn: fromDatatype.VarcharDatatypeInterface;
  billing_cycle: fromDatatype.NumericDatatypeInterface;
  commission_money_amount: fromDatatype.NumericDatatypeInterface;
  commission_point_amount: fromDatatype.NumericDatatypeInterface;
  gendoc_invoice_amount: fromDatatype.NumericDatatypeInterface;
  gendoc_payment_amount: fromDatatype.NumericDatatypeInterface;
  sales_doc_amount_net: fromDatatype.NumericDatatypeInterface;
  sales_doc_amount_cost: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  commission_date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  commission_date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  posting_membership: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_sales_commission_report_hdr_RowClass
  implements bl_fi_sales_commission_report_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  comp_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_guid: fromDatatype.GuidDataFieldInterface;
  mlm_upline_entity_guid: fromDatatype.GuidDataFieldInterface;
  mlm_upline_membership_guid: fromDatatype.GuidDataFieldInterface;
  mlm_program_participant_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_invoice_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_payment_guid: fromDatatype.GuidDataFieldInterface;
  report_type: fromDatatype.VarcharDatatypeInterface;
  report_code: fromDatatype.VarcharDatatypeInterface;
  report_name: fromDatatype.VarcharDatatypeInterface;
  mlm_lineage_absolute_level: fromDatatype.VarcharDatatypeInterface;
  client_status_01: fromDatatype.VarcharDatatypeInterface;
  client_status_02: fromDatatype.VarcharDatatypeInterface;
  client_status_03: fromDatatype.VarcharDatatypeInterface;
  client_status_04: fromDatatype.VarcharDatatypeInterface;
  client_status_05: fromDatatype.VarcharDatatypeInterface;
  commission_money_currency: fromDatatype.VarcharDatatypeInterface;
  commission_point_currency: fromDatatype.VarcharDatatypeInterface;
  gendoc_invoice_currency: fromDatatype.VarcharDatatypeInterface;
  gendoc_payment_currency: fromDatatype.VarcharDatatypeInterface;
  sales_doc_amount_txn: fromDatatype.VarcharDatatypeInterface;
  billing_cycle: fromDatatype.NumericDatatypeInterface;
  commission_money_amount: fromDatatype.NumericDatatypeInterface;
  commission_point_amount: fromDatatype.NumericDatatypeInterface;
  gendoc_invoice_amount: fromDatatype.NumericDatatypeInterface;
  gendoc_payment_amount: fromDatatype.NumericDatatypeInterface;
  sales_doc_amount_net: fromDatatype.NumericDatatypeInterface;
  sales_doc_amount_cost: fromDatatype.NumericDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  commission_date_valid_from: fromDatatype.TimestampTzDatatypeInterface;
  commission_date_valid_to: fromDatatype.TimestampTzDatatypeInterface;
  posting_membership: fromDatatype.VarcharDatatypeInterface;
}
